import React from 'react';
import {Controller} from 'react-hook-form';
import {
    FormError,
    FormLabel,
    getInputClassNames,
    getInputWrapperClass,
    getWholeDivWrapperClass,
    SUFFIX_CLASS
} from "./sharedStyles.tsx";
import {FormComponentProps, TextFieldComponent} from "../DynamicFormTypes.ts";
import {ValidationFactory} from "../ValidationFactory.ts";
import {useFormMethods} from "../DyanmicFormContext.tsx";
import {useFieldBlurHandler} from "../hooks/OnFieldBlurHanlder.tsx";
import {useValidationRules} from "../hooks/useValidationRules.tsx";

const TextFieldRenderer: React.FC<FormComponentProps<TextFieldComponent>> = ({ component }) => {
    const { formMethods } = useFormMethods()

    // Build validation rules
    const validate = useValidationRules({ component });

    const { handleFieldBlur } = useFieldBlurHandler({
        component
    });
    
    const max = ValidationFactory.getMaxValue(component, undefined);

    return (
        <>
        <div className={getWholeDivWrapperClass(component)}>
            <FormLabel component={component} />

            <div className={getInputWrapperClass(component) + (component.suffix && ' flex')}>
                <Controller
                    name={component.fieldKey}
                    control={formMethods.control}
                    rules={validate}
                    render={({ field, fieldState }) => (
                        <>
                            <input
                                id={component.fieldKey}
                                type="text"
                                placeholder={component.placeHolder}
                                max={max}
                                className={getInputClassNames(component, fieldState)}
                                {...field}
                                value={(field.value == null || field.value == undefined) ? '' : field.value}
                                onBlur={(_e) => {
                                    field.onBlur();
                                    handleFieldBlur();
                                }}
                            />
                            {component.suffix &&
                                <span className={SUFFIX_CLASS.replace("text-sm", "text-xs")}>{component.suffix}</span>
                            }
                            <FormError fieldState={fieldState} component={component}  />
                        </>
                    )}
                />
            </div>

            {max && (
                <div className="flex justify-end">
                    <p className="mt-1 text-xs text-gray-500">
                        Max: {max} characters
                    </p>
                </div>
            )}

        </div>
        </>
    );
}

export const TextField = React.memo(TextFieldRenderer);